import { GET_ORDERS_DETAILS } from "../../utils/stringConsts";

const initialState = {
  assurance: {},
  deliveryType: "",
  destination: "",
  origin: "",
  packages: [],
  packing: [],
  paymentStat: null,
  paymentTime: "",
  paymentType: "",
  price: "",
  recepientAddress: "",
  recepientName: "",
  recepientPhoneNumber: "",
  recepientPostalCode: null,
  senderAddress: "",
  senderName: "",
  senderPhoneNumber: "",
  serviceFee: {},
  serviceType: "",
  status: "",
  statusId: 0,
  theDate: "",
  theTime: "",
  trackingNumber: "",
};

export const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDERS_DETAILS:
      const {
        assurance,
        deliveryType,
        destination,
        origin,
        packages,
        packing,
        paymentStat,
        paymentTime,
        paymentType,
        price,
        recepientAddress,
        recepientName,
        recepientPhoneNumber,
        recepientPostalCode,
        senderAddress,
        senderName,
        senderPhoneNumber,
        serviceFee,
        serviceType,
        status,
        statusId,
        theDate,
        theTime,
        trackingNumber,
      } = action.payload;
      return {
        ...state,
        assurance,
        deliveryType,
        destination,
        origin,
        packages,
        packing,
        paymentStat,
        paymentTime,
        paymentType,
        price,
        recepientAddress,
        recepientName,
        recepientPhoneNumber,
        recepientPostalCode,
        senderAddress,
        senderName,
        senderPhoneNumber,
        serviceFee,
        serviceType,
        status,
        statusId,
        theDate,
        theTime,
        trackingNumber,
        isShowDetails: true,
      };
    default:
      return state;
  }
};
